import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconClapboardWide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconClapboardWide"><Path d="M21.5 4.5H2.5V19.5H21.5V4.5Z" stroke="currentColor"/><Path d="M2.5 9.5H21.5" stroke="currentColor"/><Path d="M7.75 9.5L9.75 4.5" stroke="currentColor"/><Path d="M14.25 9.5L16.25 4.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconClapboardWide;
